import * as React from "react";
import { css } from "emotion";
import Byline from "./Byline";
import Line from "./Line";
import { colors, mediaQueries } from "../shared/config";

export enum XPosition {
  Left = "start",
  Center = "center",
  Right = "end"
}

export enum YPosition {
  Top = "start",
  Center = "center",
  Bottom = "end"
}

interface CoverPhotoProps {
  headline: string;
  imageURL: string;
  // imageCredit: string;
  description: string;
  darken?: number;
  style?: string;
  // explainer?: string;
  textColor: string;
}

export default class CoverPhoto extends React.Component<CoverPhotoProps> {
  public static defaultProps = {
    darken: 0,
    textColor: "#fff"
  };

  public render() {
    const { mobile } = mediaQueries;
    const { imageURL, description } = this.props;
    return (
      <div
        className={css`
          width: 100%;
          height: 65vh;
          background-image: url();
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          background-size: contain;
          /* background-color: #82a6c1; */
          background-color: #e4f6f8;
          background: linear-gradient(white, #e4f6f8);
          margin-bottom: 40px;
          padding: 40px 0;
          display: grid;
          color: white;
          position: relative;
          overflow: hidden;
          ${this.props.style};
        `}
      >
        <img
          src="https://i.imgur.com/c6OJnyX.png"
          className={css`
            position: absolute;
            align-self: center;
            max-width: 100%;
            left: 50%;
            transform: translate(-50%, 0);
          `}
        />
        <div
          className={css`
            align-self: center;
            max-width: 500px;
            z-index: 10;
            display: flex;
            margin: auto;
            flex-direction: column;
            background-color: rgba(0, 0, 0, 0.6);
            &:hover {
              opacity: 0;
            }
            transition: 0.5s;
            padding: 30px;
          `}
        >
          <div
            className={css`
              margin: 0;
              line-height: 70px;
              font-size: 4rem;
              ${mobile} {
                font-size: 3rem;
                line-height: 55px;
              }
            `}
          >
            {this.props.headline}
          </div>
          <Line />
          <div className={css``}>{description}</div>
          {/* {!!this.props.explainer && <p>{this.props.explainer}</p>} */}
        </div>
      </div>
    );
  }
}
